export default __webpack_public_path__ + "static/media/top-b-10.190c77b0.jpg";